import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import ModalContainer from 'containers/ProductRegist/components/common/ModalContainer';
import Column from 'components/common/Column';
import Text from 'components/common/Text';
import Row from 'components/common/Row';
import Textarea from 'containers/ProductRegist/components/common/Textarea';
import { useMutationTicketsSale } from 'containers/SaleDetail/graphQL/hooks/useMutationTicketsSale';
import { useQueryCheckExistenceOfInvoice } from 'containers/SaleDetail/graphQL/hooks/useQueryCheckExistenceOfInvoice';
import { OrderItem } from 'types/api';
import { errorHandler } from 'utils/ErrorHandler';
import { debounce } from 'lodash';

const RadioBox = styled.input`
  width: 24px;
  height: 24px;
  appearance: none;
  border: 3px solid #eee;
  border-radius: 50%;
  cursor: pointer;

  &:checked {
    border: 8px solid #1b1c1e;
  }
`;

const FloatingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  bottom: 0;
  padding: 16px 20px 24px 20px;
  margin-top: auto;

  width: 100%;
  background-color: #fff;
  border-radius: 0 0 16px 16px;
  border-top: 1px solid #eaebec;
`;

const CANCEL_ORDER_PARAM = [
  {
    value: 'USER',
    label: '고객 변심',
  },
  {
    value: 'HOST',
    label: '호스트 사정',
  },
];
interface Props {
  isMobile: boolean;
  orderItems: OrderItem[];
  onClose: () => void;
  handleRequestCancelOrders: (param: any, callback: () => void) => void;
  handleRefetchDeliveryList: () => void;
  handleCloseDeliveryDetail: () => void;
}

const DeliveryCancelModal: FC<Props> = props => {
  const {
    isMobile,
    orderItems,
    onClose,
    handleRequestCancelOrders,
    handleRefetchDeliveryList,
    handleCloseDeliveryDetail,
  } = props;

  const [cancelOrderParam, setCancelOrderParam] = useState({
    items: [],
    kind: 'USER',
    reason: '',
  });

  const handleSetCancelOrderParam = (key: string, value: any) => {
    setCancelOrderParam({ ...cancelOrderParam, [key]: value });
  };

  const handleDeliveryRequestCancel = () => {
    if (cancelOrderParam.reason.trim() !== '') {
      handleRequestCancelOrders(cancelOrderParam, () => {
        onClose();
        handleRefetchDeliveryList();
        handleCloseDeliveryDetail();
      });
    }
  };

  useEffect(() => {
    setCancelOrderParam(prev => ({
      ...prev,
      items: orderItems.map(item => ({
        orderItemId: item.id,
        indices: item.units.map(unit => unit.indexNo),
        quantity: -item.units.length,
      })),
    }));
  }, [orderItems]);

  return (
    <ModalContainer
      isBottomSheet={true}
      isMobile={isMobile}
      isAbled={true}
      onClose={() => {}}
      onAcceptText="취소 요청하기"
      onClick={() => {}}
    >
      <Column align="flex-start" gap="24px" style={{ padding: '28px 20px' }}>
        <Text
          color="#1B1C1E"
          size="20px"
          weight={600}
          style={{ lineHeight: '28px' }}
        >
          주문 취소는 관리자의 확인 후 <br /> 취소가 완료됩니다.
        </Text>
        <Column gap="12px" align="flex-start">
          <Text color="#1b1c1e" size="16px">
            주문 취소 사유
          </Text>
          <Row gap="16px">
            {CANCEL_ORDER_PARAM.map(item => {
              return (
                <Row
                  gap="8px"
                  key={item.value}
                  onClick={() => {
                    handleSetCancelOrderParam('kind', item.value);
                  }}
                >
                  {' '}
                  <RadioBox
                    type="radio"
                    checked={cancelOrderParam.kind === item.value}
                    onChange={() =>
                      handleSetCancelOrderParam('kind', item.value)
                    }
                  />
                  <Text
                    color={cancelOrderParam.kind === item.value && '#1b1c1e'}
                  >
                    {item.label}
                  </Text>
                </Row>
              );
            })}
          </Row>
        </Column>
        <Column gap="12px" align="flex-start">
          <Text color="#1b1c1e" size="16px">
            상세 사유
          </Text>
          <Textarea
            target="reason"
            value={cancelOrderParam.reason}
            placeholder="자세한 사유를 입력해 주세요"
            onChange={handleSetCancelOrderParam}
            style={{ minHeight: '110px', fontSize: '16px', lineHeight: '24px' }}
          />
        </Column>
      </Column>
      <FloatingContainer>
        <Text
          color="#70737C"
          size="16px"
          style={{ cursor: 'pointer' }}
          onClick={onClose}
        >
          닫기
        </Text>
        <Row
          gap="4px"
          style={{
            padding: '12px 24px',
            borderRadius: '12px',
            background:
              cancelOrderParam.reason.trim() !== '' ? '#FFE6E6' : '#F4F4F5',
            cursor: 'pointer',
          }}
          onClick={debounce(() => {
            handleDeliveryRequestCancel();
          }, 500)}
        >
          <Text
            color={
              cancelOrderParam.reason.trim() !== '' ? '#FF4242' : '#DBDCDF'
            }
            size="16px"
            weight={600}
          >
            주문 취소 요청하기
          </Text>
        </Row>
      </FloatingContainer>
    </ModalContainer>
  );
};

export default DeliveryCancelModal;
